import { AttendState } from 'components/common/AttendState';
import AttendancePopup from 'components/popup/AttendancePopup';
import { Sidebar } from 'components/shared/sidebar';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Form, Tab, Table, Tabs } from 'react-bootstrap';
import { loginUser } from 'recoil/loginUser';
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { useGetRequiredApi } from "hooks/useGetRequiredApi";
import { useMutation, useQueries, useQuery } from "@tanstack/react-query";
import { getDataQuery } from "api";
import { useNavigate } from "react-router";
import { subjectTeacherState } from "recoil/subject/subjectTeacherState";
import { adminSubjectState } from "recoil/subject/adminSubjectState";
import { useGetAdminSubjectQuery } from "hooks/useGetAdminSubjectQuery";
import { useGetCommonApi } from "hooks";
import { getSessionStorage, setSessionStorage } from "assets/constant";
import * as XLSX from 'xlsx-js-style';
import { applyExcelStyles, applyCenterAlignment, writeExcelFile } from 'util/excelStyle';
import { downloadLoadingState } from 'recoil/loading/downloadLoadingState';
import moment from 'moment';
import { postDataBodyQuery } from 'api/getDataBodyQuery';
import { postDataQuery } from 'api/board/postQuery';
import { subjectOptionDataState } from 'recoil/subject/subjectOptionDataState';

export const AttendanceTeacher = () => {
  const [key, setKey] = useState('Attendance');
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(""); // 상단 선택 상태
  const [selectedStudent, setSelectedStudent] = useState({ name: '', studentId: '', statusList: [] });
  const [isOnsiteUsed, setIsOnsiteUsed] = useState(true);
  const user = useRecoilValue(loginUser);
  const [rows, setRows] = useState(
    Array.from({ length: 9 }, () => ({ status: "" })) // 각 요소를 독립된 객체로 생성
  );
  // 주차, 날짜, 교시 선택 상태
  const [selectedWeek, setSelectedWeek] = useState("1");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedPeriod, setSelectedPeriod] = useState("1");

  // 필터링된 데이터 상태
  const [filteredAttendanceList, setFilteredAttendanceList] = useState([]);
  const navigate = useNavigate();
  const setSubjectTeacherState = useSetRecoilState(subjectTeacherState);
  const subjectTeacherData = JSON.parse(getSessionStorage('subjectDetailData'));
  const [subjectId, setSubjectId] = useState(null);
  const [optionData, setOptionData] = useState([]);
  const [subOptionData, setSubOptionData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [attendanceFilter, setAttendanceFilter] = useState(null);
  const [adminSelectState, setAdminSelectState] = useRecoilState(adminSubjectState);
  const [attendanceSetting, setAttendanceSetting] = useState({
    useFlag: 'Y',
    totalPoint: 0,
    minPoint: 0,
    latePenaltyPoint: 0,
    absencePenaltyPoint: 0,
  });

  const subjectState = useRecoilValue(subjectOptionDataState);
  const [adminSubjectList, setAdminSubjectList] = useState([]);
  // 어드민 전체 과목 불러오기 전체 학과 리스트 조회
  const { adminSubjectDepartmentData, adminSubjectDepartmentIsLoading, adminSubjectDepartmentIsError } =
    useGetAdminSubjectQuery();
  //   const { teacherSubjectTitleData } = useGetTeacherQuery();
  const { semesterData, semesterIsLoading, semesterIsError } = useGetCommonApi();

  const {
    // 관리자 - 전체 학과 리스트 조회
    adminSelectBoxQueryData,

    // 관리자 - 해당 학과의 과목 리스트
    adminSubSelectBoxQueryData,
  } = useGetRequiredApi(adminSelectState.lectureId);

  const teacherSubjectApis = useQueries({
    queries: [
      {
        // 교수자 - [학습현황] 과목을 수강중인 학생들의 목록
        queryKey: ['teacherSubjectStudentList', user, adminSelectState],
        queryFn: () => getDataQuery(`/teach/courses/${adminSelectState.subjectId}/students`),
        enabled: !!adminSelectState.subjectId,
      },
      {
        // 교수자 - [출결현황] 출결 데이터
        queryKey: ['teacherAttendanceList', user, adminSelectState],
        queryFn: () => getDataQuery(`/attendance/course/${adminSelectState.subjectId}`),
        enabled: !!adminSelectState.subjectId,
      },
      {
        // 교수자 - [출결현황] 출석평가표
        queryKey: ['teacherAttendanceSettingList', user, adminSelectState],
        queryFn: () => getDataQuery(`/course/${adminSelectState.subjectId}/attendance-setting`),
        enabled: !!adminSelectState.subjectId,
      },
    ],
  });

  const [
    teacherSubjectStudentListData,
    teacherAttendanceList,
    teacherAttendanceSettingList,
  ] = teacherSubjectApis?.map((query) => query?.data?.data);

  const [
    refetchSubjectStudentListData, 
    refetchAttendanceList,
    refetchAttendanceSettingList,  
  ] = teacherSubjectApis?.map((query) => query?.refetch) || [];

  const filteredStudents = teacherSubjectStudentListData?.filter((student) => {
    return (
      student.name.includes(searchTerm) || // 이름에 검색어가 포함되어 있는지
      student.userNumber.includes(searchTerm) // 학번에 검색어가 포함되어 있는지
    );
  });

  const attendanceDisplayStudents = useMemo(() => {
    if (!filteredStudents || attendanceFilter === null) return filteredStudents;
    return filteredStudents.filter((item) => {
      const attendanceData = teacherAttendanceList?.find(
        (student) => student.userNumber === item.userNumber
      );
      const absenceCnt = Number(attendanceData?.absenceCnt ?? 0);
      return attendanceFilter === 'attendance' ? absenceCnt <= 0 : absenceCnt > 0;
    });
  }, [filteredStudents, teacherAttendanceList, attendanceFilter]);

  const handleSetSubjectDetail = (item) => {
    try {
      const subjectDetailData = {
        courseId: adminSelectState.subjectId,
        moduleId: item.module_id,
        assignment: item.content_id,
        studentLmsUserIds: teacherSubjectStudentListData?.student_id_list,
        course_title: adminSelectState.title,
        title: adminSelectState.title,
        ...adminSelectState,
      };

      setSubjectTeacherState(subjectDetailData);

      setSessionStorage(JSON.stringify(subjectDetailData), 'subjectDetailData');
      navigate('detail');
    } catch (error) {
      console.error('error', error);
    }
  };

  // 학과 이벤트 핸들러
  const handleSelectIdBox = (e) => {
    if (!e.target.value) return;
    setAdminSelectState({ ...adminSelectState, lectureId: e.target.value, lectureTitle: e.target.options[e.target.selectedIndex]?.text || '' });
  };

  // 과목 이벤트 핸들러
  const handleSubjectSelectBox = (e) => {
    const findData = adminSubSelectBoxQueryData?.find((el) => el.account_course_dto.course_id === Number(e.target.value));
    setAdminSelectState({
      ...adminSelectState,
      subjectId: e.target.value,
      total_student_count: findData?.student_count,
      title: findData?.account_course_dto.course_name,
      subjectTitle: e.target.options[e.target.selectedIndex]?.text || '',
    });
  };

  // 학과 셀렉트 박스 데이터
  useEffect(() => {
    return setOptionData(
      adminSelectBoxQueryData?.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    );
  }, [adminSelectBoxQueryData]);

  // 과목 셀렉트 박스 데이터
  useEffect(() => {
    return setSubOptionData(
      adminSubSelectBoxQueryData?.map((item) => ({
        value: item.account_course_dto.course_id,
        label: item.account_course_dto.course_name,
      }))
    );
  }, [adminSubSelectBoxQueryData]);

  useEffect(() => {
    if (teacherAttendanceList) {
      // 필터링 조건이 없을 경우 전체 데이터를 기본값으로 설정
      const filteredData = teacherAttendanceList.flatMap((item) =>
        item.attendanceSummaryDtoList.map((summary) => ({
          userId: item.userNumber,
          name: item.name.trim(),
          subDivision: item.subDivision,
          ...summary, // moduleNumber, attendanceSummaries 등 포함
        }))
      );
      setFilteredAttendanceList(filteredData);
    }
  }, [teacherAttendanceList]);
  
  useEffect(() => {
    if (teacherAttendanceList) {
      const filteredData = teacherAttendanceList.flatMap((item) =>
        item.attendanceSummaryDtoList.filter((summary) => {
          const matchWeek = selectedWeek ? summary.moduleNumber == selectedWeek : true;
          const matchDate = selectedDate
          ? summary.attendanceSummaries.some((content) => {
              const summaryDateFormatted = new Date(content.date).toLocaleDateString("en-CA");
              const selectedDateFormatted = new Date(selectedDate).toLocaleDateString("en-CA");
              return summaryDateFormatted === selectedDateFormatted;
            })
          : true;
          const matchPeriod = selectedPeriod ? summary.attendanceSummaries.some(content => content.contentNumber == selectedPeriod) : true;
          return matchWeek && matchDate && matchPeriod;
        }).map((summary) => ({
          userId: item.userNumber,
          name: item.name.trim(),
          subDivision: item.subDivision,
          ...summary, // moduleNumber, attendanceSummaries 등 포함
        }))
      );
      setFilteredAttendanceList(filteredData);
    }
  }, [selectedWeek, selectedDate, selectedPeriod, teacherAttendanceList]);

  useEffect(() => {
    if (!selectedDate && teacherAttendanceList) {
      const defaultDate = teacherAttendanceList[0]?.attendanceSummaryDtoList[0]?.attendanceSummaries[0]?.date;
      if (defaultDate) setSelectedDate(formatDate(defaultDate));
    }
  }, [teacherAttendanceList]);

  // 필터링된 데이터 상태 업데이트
  useEffect(() => {
    if (filteredAttendanceList && filteredAttendanceList.length > 0) {
      // filteredAttendanceList가 이미 존재하면 아무 작업도 하지 않음
      return;
    }

    if (teacherAttendanceList && teacherAttendanceList.length > 0) {
      const newFilteredData = teacherAttendanceList.map((item) => {
        // 기본 데이터 생성
        const attendanceSummaries = [
          {
            attendanceState: "", // 기본값으로 초기화
            contentNumber: selectedPeriod || 1, // 선택된 교시 또는 기본값 1
            date: selectedDate || formatDate(new Date()), // 선택된 날짜 또는 현재 날짜
            moduleNumber: selectedWeek || 1, // 선택된 주차 또는 기본값 1
          },
        ];

        return {
          userId: item.userNumber,
          name: item.name.trim(),
          subDivision: item.subDivision,
          moduleNumber: selectedWeek || 1,
          attendanceSummaries,
        };
      });

      setFilteredAttendanceList(newFilteredData);
    }
  }, [filteredAttendanceList, teacherAttendanceList, selectedWeek, selectedPeriod, selectedDate]);

  useEffect(() => {
    if (teacherAttendanceSettingList) {
      setAttendanceSetting({
        useFlag: teacherAttendanceSettingList.useFlag || "Y",
        totalPoint: teacherAttendanceSettingList.totalPoint || 0,
        minPoint: teacherAttendanceSettingList.minPoint || 0,
        latePenaltyPoint: teacherAttendanceSettingList.latePenaltyPoint || 0,
        absencePenaltyPoint: teacherAttendanceSettingList.missPenaltyPoint || 0, // API에서는 missPenaltyPoint로 사용
      });
    }
  }, [teacherAttendanceSettingList]);

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // 일괄 상태 처리
  const handleBulkStatusChange = () => {
    if (!filteredAttendanceList || filteredAttendanceList.length === 0) {
      return;
    }

    if (!selectedStatus || selectedStatus === "초기화") {
      // 상태 초기화 처리
      const resetData = filteredAttendanceList.map((item) => ({
        ...item,
        attendanceSummaries: item.attendanceSummaries
          ? item.attendanceSummaries.map((summary) => ({
              ...summary,
              attendanceState: "", // 상태 초기화
            }))
          : [], // attendanceSummaries가 없을 경우 빈 배열 유지
      }));
      setFilteredAttendanceList(resetData);
      return;
    }

    // 선택된 상태로 업데이트
    const updatedData = filteredAttendanceList.map((item) => ({
      ...item,
      attendanceSummaries: item.attendanceSummaries
        ? item.attendanceSummaries.map((summary) => ({
            ...summary,
            attendanceState:
              selectedStatus === "출석"
                ? "ATTENDANCE"
                : selectedStatus === "공결"
                ? "EXCUSED_ABSENCE"
                : selectedStatus === "지각"
                ? "LATE"
                : selectedStatus === "결석"
                ? "ABSENCE"
                : summary.attendanceState, // 기본값 유지
          }))
        : [], // attendanceSummaries가 없을 경우 빈 배열 유지
    }));
    setFilteredAttendanceList(updatedData);
  };



// 라디오 버튼 상태 변경
const handleRowStatusChange = (teacherIndex, status) => {
  const selectedStudent = filteredStudents[teacherIndex]; // 선택된 학생

  // filteredAttendanceList 업데이트
  const updatedFilteredList = filteredAttendanceList.map((item) => {
    if (item.userId === selectedStudent.userNumber) {
      // 기존 데이터가 있으면 업데이트
      return {
        ...item,
        attendanceSummaries: item.attendanceSummaries.map((summary) => ({
          ...summary,
          attendanceState: status, // 새로운 상태 반영
        })),
      };
    }
    return item;
  });

  // 새로운 데이터 추가 (filteredAttendanceList에 해당 학생 데이터가 없을 경우)
  const isStudentInAttendanceList = filteredAttendanceList.some(
    (item) => item.userId === selectedStudent.userNumber
  );

  if (!isStudentInAttendanceList) {
    updatedFilteredList.push({
      userId: selectedStudent.userNumber,
      name: selectedStudent.name.trim(), // 이름 처리
      subDivision: selectedStudent.subDivision,
      moduleNumber: 1, // 기본 값 설정 (필요 시 수정)
      attendanceSummaries: [
        {
          moduleId: 1, // 모듈 ID 설정
          attendanceState: status, // 새로운 상태
        },
      ],
    });
  }

  setFilteredAttendanceList(updatedFilteredList); // 상태 업데이트

  // rows 상태 업데이트
  const updatedRows = [...rows];
  updatedRows[teacherIndex] = { status };
  setRows(updatedRows);
};

  // 이름 클릭 시 모든 데이터를 전달
  const handleNameClick = (studentId, name, statusList) => {
    const attendanceStates = statusList.map((status) => status.attendanceState);
  
    setSelectedStudent({ studentId, name, statusList }); // 상태 추가
    setVisiblePopup(true);
  };
  

  const handleOnsiteUsageChange = (e) => {
    setIsOnsiteUsed(e.target.value === '예'); // '예'일 경우 true, '아니오'는 false
  };

  // 엑셀 다운로드 함수
  const setDownloadLoading = useSetRecoilState(downloadLoadingState);
  const handleDownloadExcel = async () => {
    setDownloadLoading(true);
    await new Promise(resolve => setTimeout(resolve, 100));
    try {
    const wsData = [];

    // 헤더 생성
    const headers = [
      "번호",
      "이름",
      "학번",
      "학과",
      "출석/공결일수",
      "지각일수",
      "결석일수",
      ...Array.from({ length: 15 }, (_, i) => `${i + 1}주차`), // 1주차, 2주차 형식
    ];
    wsData.push(headers);
  
    // 데이터 생성
    attendanceDisplayStudents?.forEach((item, index) => {
      const attendanceData = teacherAttendanceList?.find(
        (student) => student.userNumber === item.userNumber
      );
  
      if (attendanceData) {
        // 각 주차 데이터를 문자열로 변환
        const attendanceSummary = attendanceData.attendanceSummaryDtoList.slice(0, 15).map((week) => {
          return week.attendanceSummaries
            .map((summaryItem) => {
              switch (summaryItem.attendanceState) {
                case "ATTENDANCE":
                  return "출석";
                case "LATE":
                  return "지각";
                case "EXCUSED_ABSENCE":
                  return "공결";
                case "ABSENCE":
                  return "결석";
                default:
                  return "";
              }
            })
            .join(", "); // 쉼표로 상태를 구분
        });
  
        // 행 데이터 생성
        wsData.push([
          index + 1,
          attendanceData.name,
          attendanceData.userNumber,
          attendanceData.subDivision,
          attendanceData.attendanceCnt,
          attendanceData.lateCnt,
          attendanceData.absenceCnt,
          ...attendanceSummary, // 주차 데이터 추가
        ]);
      }
    });
  
    // 워크시트 생성
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    applyExcelStyles(ws, 1);
    applyCenterAlignment(ws, 7);

    // 워크북 생성
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Attendance");

    // 파일 다운로드
    const courseName = subjectState.courseName || '';
    const termName = subjectState.termName || '';
    writeExcelFile(wb, `${courseName}_출석_${termName}_${moment().format('YYMMDD_HHmm')}.xlsx`);
    } finally {
      setDownloadLoading(false);
    }
  };
  

  const handleFilterChange = (type, value) => {
    let updatedWeek = selectedWeek;
    let updatedDate = selectedDate;
    let updatedPeriod = selectedPeriod;
  
    if (type === "week") updatedWeek = value;
    if (type === "date") updatedDate = value;
    if (type === "period") updatedPeriod = value;
    // 필터링된 데이터 업데이트
    const filteredData = teacherAttendanceList.flatMap((item) =>
      item.attendanceSummaryDtoList.filter((summary) => {
        const matchWeek = summary.moduleNumber == updatedWeek;
        const matchDate = updatedDate
          ? summary.attendanceSummaries.some((s) => s.date === updatedDate)
          : true;
        const matchPeriod = updatedPeriod
          ? summary.attendanceSummaries.some((s) => s.contentNumber == updatedPeriod)
          : true;
  
        return matchWeek && matchDate && matchPeriod;
      })
    );
  
    // 상태 업데이트
    if (type === "week") setSelectedWeek(value);
    if (type === "date") setSelectedDate(value);
    if (type === "period") setSelectedPeriod(value);
    setFilteredAttendanceList(filteredData);
  };

  const writeMutation = useMutation({
    mutationFn: (formData) => postDataQuery(`/attendance/course/${adminSelectState.subjectId}`, formData),
    onSuccess: () => {
    },
    onError: (error) => {
      console.error("등록 실패:", error);
    },
  });

  const writeAttendanceSettingMutation = useMutation({
    mutationFn: (formData) => postDataQuery(`/course/attendance-setting`, formData),
    onSuccess: () => {
    },
    onError: (error) => {
      console.error("등록 실패:", error);
    },
  });
  
  const handleRegister = (e) => {
    e.preventDefault();
  
    // 출결 데이터 추가
    const attendanceCreateDtoList = filteredAttendanceList.map((item) => ({
      userId: item.userId,
      attendanceState: item.attendanceSummaries[0]?.attendanceState,
    }));
  
    // 비어 있는 상태 확인
    const hasEmptyState = attendanceCreateDtoList.some(
      (dto) => !dto.attendanceState || dto.attendanceState.trim() === ""
    );
  
    if (hasEmptyState) {
      alert("출결현황을 모두 체크해주셔야 합니다."); // 경고 메시지 띄우기
      return; // 실행 중단
    }
  
    const formData = new FormData();
  
    // JSON 데이터로 변환 후 FormData에 추가
    const attendanceJson = JSON.stringify(attendanceCreateDtoList);
    const attendanceBlob = new Blob([attendanceJson], { type: "application/json" });
    formData.append("attendanceCreateDtoList", attendanceBlob);
  
    // 추가 파라미터 설정
    formData.append("moduleNumber", selectedWeek); // 주차
    formData.append("contentNumber", selectedPeriod); // 차시
    formData.append("date", selectedDate); // 날짜
  
    // 서버로 전송
    writeMutation.mutate(formData, {
      onSuccess: () => {
        alert("등록 성공");
  
        // 서버에서 최신 데이터 가져오기
        refetchAttendanceList(); // React Query의 refetch 함수 호출
      },
      onError: (error) => {
        console.error("등록 실패:", error);
      },
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAttendanceSetting((prev) => ({
      ...prev,
      [name]: name === "useFlag" ? value : parseInt(value, 10) || 0,
    }));
  };

  
  

  const handleAttendanceSettingSubmit = async () => {
    const attendanceSettingCreateDto = {
      lmsCourseId: adminSelectState.subjectId,
      useFlag: attendanceSetting.useFlag,
      totalPoint: attendanceSetting.totalPoint,
      minPoint: attendanceSetting.minPoint,
      latePenaltyPoint: attendanceSetting.latePenaltyPoint,
      absencePenaltyPoint: attendanceSetting.absencePenaltyPoint,
    };
  
    const formData = new FormData();
  
    // JSON 데이터로 변환 후 FormData에 추가
    const attendanceSettingJson = JSON.stringify(attendanceSettingCreateDto);
    const aattendanceSettingBlob = new Blob([attendanceSettingJson], { type: "application/json" });
    formData.append("attendanceSettingCreateDto", aattendanceSettingBlob);
  
    // 서버로 전송
    writeAttendanceSettingMutation.mutate(formData, {
      onSuccess: () => {
        alert("등록 성공");
        refetchAttendanceSettingList();
      },
      onError: (error) => {
        console.error("등록 실패:", error);
      },
    });
  };
  
  return (
    <>
      <Sidebar />
      <div className="d-flex justify-content-start align-items-center"
           style={{ gap: "4rem" }}>
            {user.role === 'ADMIN' && (
                <div className='d-flex align-items-center mt-2 mb-4'>
                <label className='me-2' htmlFor='subjectWeek'>
                  학과
                </label>
                <Form.Select
                  id="subjectWeek"
                  name="subjectWeek"
                  onChange={handleSelectIdBox}
                  style={{ width: "200px" }}
                >
                  <option value="">학과 선택</option>
                  {adminSelectBoxQueryData?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            )}
            {/* 담당교수/지도교수 선택 - 2025년도 이상일 때만 표시 */}
            {parseInt(subjectState.openYy) >= 2025 && (
            <>
            <div className='d-flex align-items-center mt-2 mb-4'>
              <label className='me-2' htmlFor='subjectWeek'>
                담당교수
              </label>
              <Form.Select
                id='subjectWeek'
                name='subjectWeek'
                disabled
                style={{ width: '200px' }}
              >
                <option value='1'>담당교수 선택</option>
              </Form.Select>
            </div>
            <div className='d-flex align-items-center mt-2 mb-4'>
              <label className='me-2' htmlFor='subjectWeek'>
                지도교수
              </label>
              <Form.Select
                id='subjectWeek'
                name='subjectWeek'
                disabled
                style={{ width: '200px' }}
              >
                <option value='1'>지도교수 선택</option>
              </Form.Select>
            </div>
            </>
            )}
            <div className='d-flex align-items-center mt-2 mb-4'>
              <label className='me-2' htmlFor='subjectWeek'>
                과목
              </label>
              <Form.Select
                id='subjectWeek'
                name='subjectWeek'
                onChange={handleSubjectSelectBox}
                style={{ width: '200px' }}
              >
                <option value="">과목 선택</option>
                {adminSubSelectBoxQueryData?.map((item) => (
                  <option key={item.account_course_dto.course_id} value={item.account_course_dto.course_id}>
                    {item.account_course_dto.course_name}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>
          {teacherAttendanceList && teacherAttendanceList.length > 0 ? (
          <Tabs id='controlled-tab-example' activeKey={key} onSelect={(k) => setKey(k)} className='mb-3'>
            <Tab eventKey='Attendance' title='출석부'>
              <div>
                <div className='d-flex'>
                  {/* 날짜 */}
                  <div className="d-flex align-items-center me-5">
                    <label className="me-2" htmlFor="subjectDateInput">날짜</label>
                    <input
                      type="date"
                      className="p-2 border rounded"
                      name="subjectDateInput"
                      id="subjectDateInput"
                      value={selectedDate} // 날짜가 선택된 상태 유지
                      onChange={(e) => handleFilterChange("date", e.target.value)}
                    />
                  </div>
                  {/* 출결주차 */}
                  <div className='d-flex align-items-center me-5'>
                    <label className='me-2' htmlFor='subjectWeek'>출결주차</label>
                    <Form.Select
                      aria-label='Default select example'
                      id='subjectWeek'
                      name='subjectWeek'
                      onChange={(e) => handleFilterChange("week", e.target.value)}
                      value={selectedWeek} // 현재 선택된 값 유지
                      style={{ width: '130px' }}
                    >
                      {Array.from(new Set(teacherAttendanceList?.flatMap(item => item.attendanceSummaryDtoList.map(module => module.moduleNumber)))).map((week) => (
                        <option key={week} value={week}>{week}주차</option>
                      ))}
                    </Form.Select>
                  </div>
                  {/* 교시 */}
                  <div className='d-flex align-items-center'>
                    <label className='me-2' htmlFor='periodInput'>교시</label>
                    <Form.Select
                      aria-label='Default select example'
                      id='periodInput'
                      name='periodInput'
                      onChange={(e) => handleFilterChange("period", e.target.value)}
                      value={selectedPeriod} // 현재 선택된 값 유지
                      style={{ width: '130px' }}
                    >
                    {Array.from(
                      new Set(
                        teacherAttendanceList?.flatMap(item =>
                          item.attendanceSummaryDtoList.flatMap(module =>
                            module.attendanceSummaries.map(content => content.contentNumber)
                          )
                        )
                      )
                    ).map((period, index) => (
                      <option key={`${period}-${index}`} value={period}>
                        {period}교시
                      </option>
                    ))}
                    </Form.Select>
                  </div>
                </div>
                <div className='d-flex justify-content-end mt-3 pb-3 border border-start-0 border-end-0 border-top-0'>
                  <Form.Control type='text' placeholder='이름 / 학번 검색' style={{ width: '188px' }} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>
                <p className='p-3 fw-bold' style={{ color: '#13426B' }}>
                  출석현황을 체크하신 후에 하단의 저장버튼을 눌러주세요.
                </p>
                <Form onSubmit={handleRegister}>
                  <ul className="d-flex justify-content-end">
                    {["출석", "공결", "지각", "결석", "초기화"].map((label) => (
                      <li key={label} className="d-flex align-items-center ms-3">
                        <Form.Check
                          type="radio"
                          id={label}
                          name="bulkStatus"
                          onChange={() => setSelectedStatus(label)}
                          checked={selectedStatus === label}
                        />
                        <label className="ms-2" htmlFor={label}>
                          {label}
                        </label>
                      </li>
                    ))}
                    <li className="ms-3">
                      <Button variant="outline-primary" onClick={handleBulkStatusChange}>
                        일괄상태처리
                      </Button>
                    </li>
                  </ul>
                
                  <Table>
                    <thead>
                      <tr className="border border-start-0 border-end-0 fw-normal">
                        <td className="col-1">번호</td>
                        <td className="col-1">이름</td>
                        <td className="col-1">학번</td>
                        <td className="col-2 border border-start-0 border-top-0 border-bottom-0">학과</td>
                        <td className="col-2">지도교수</td>
                        <td style={{ background: "#D1DEFF" }}>출석</td>
                        <td style={{ background: "#EBF1FA" }}>공결</td>
                        <td style={{ background: "#D1DEFF" }}>지각</td>
                        <td style={{ background: "#EBF1FA" }}>결석</td>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredStudents?.map((teacherAttendance, teacherIndex) => {
                        
                        // 필터링된 데이터 가져오기
                        const filteredData = filteredAttendanceList.find(
                          (filtered) => 
                            filtered.userId === teacherAttendance.userNumber &&
                            filtered.moduleNumber == selectedWeek && // 주차 조건
                            filtered.attendanceSummaries.some(
                              (item) => {
                                return (
                                  item.contentNumber == selectedPeriod
                                )
                              }
                            )
                        );

                        return (
                          <tr key={teacherIndex}>
                            {/* 기본 학생 정보 */}
                            <td className="border-bottom-0 py-3">{teacherIndex + 1}</td>
                            <td className="border-bottom-0 py-3">
                              {teacherAttendance.name.trim()}
                            </td>
                            <td className="border-bottom-0 py-3">{teacherAttendance.userNumber}</td>
                            <td className="border border-start-0 border-top-0 border-bottom-0 py-3">
                              {teacherAttendance.subDivision}
                            </td>
                            <td className="border-bottom-0 py-3">
                              {teacherAttendance.tutorName || '미배정'}
                            </td>

                            {/* 출석 상태 */}
                            {["ATTENDANCE", "EXCUSED_ABSENCE", "LATE", "ABSENCE"].map((status, statusIndex) => (
                              <td key={statusIndex} className="text-center border-bottom-0">
                                <Form.Check
                                  type="radio"
                                  name={`row-${teacherIndex}`}
                                  checked={
                                    filteredData?.attendanceSummaries.some(
                                      (item) => {
                                        return (
                                          item.attendanceState === status &&
                                          item.contentNumber == selectedPeriod
                                        )
                                      }
                                    )
                                  }
                                  onChange={() => handleRowStatusChange(teacherIndex, status)}
                                />
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <div className="d-flex justify-content-center border-top pt-3">
                    <Button type="submit" variant="primary" className="me-2">
                      등록
                    </Button>
                    <Button type="button" onClick={() => navigate(-1)} variant="secondary">
                      취소
                    </Button>
                  </div>
                </Form>
              </div>
            </Tab>
            <Tab eventKey='AttendanceStatus' title='출석현황'>
              <>
                <div className="table-container" style={{ position: 'relative' }}>
                  {/* 검색창 및 설명 */}
                  <div
                    id="sticky-header"
                    style={{
                      position: 'sticky',
                      top: 0,
                      zIndex: 10,
                      background: 'white',
                    }}
                  >
                    <div className="py-2">
                      <ul className="d-flex justify-content-end">
                        <li
                          className="me-4 d-flex"
                          style={{ cursor: 'pointer', opacity: attendanceFilter === 'attendance' ? 1 : 0.4 }}
                          onClick={() => setAttendanceFilter(prev => prev === 'attendance' ? null : 'attendance')}
                        >
                          <p>출석</p>
                          <img
                            src="assets/img/attendance.png"
                            alt="출석"
                            className="after-attendance-blue"
                            style={{ width: "20px", height: "20px", marginLeft: "5px" }}
                          />
                        </li>
                        <li className="me-4 d-flex">
                          <p>공결</p>
                          <img
                            src="assets/img/excused_absence.svg"
                            alt="공결"
                            className="after-attendance-green"
                            style={{ width: "20px", height: "20px", marginLeft: "5px" }}
                          />
                        </li>
                        <li className="me-4 d-flex">
                          <p>지각</p>
                          <img
                            src="assets/img/late.svg"
                            alt="지각"
                            className="after-attendance-yellow"
                            style={{ width: "20px", height: "20px", marginLeft: "5px" }}
                          />
                        </li>
                        <li
                          className="me-4 d-flex"
                          style={{ cursor: 'pointer', opacity: attendanceFilter === 'absence' ? 1 : 0.4 }}
                          onClick={() => setAttendanceFilter(prev => prev === 'absence' ? null : 'absence')}
                        >
                          <p>결석/미인증</p>
                          <img
                            src="assets/img/absence.svg"
                            alt="결석/미인증"
                            className="after-attendance-red"
                            style={{ width: "20px", height: "20px", marginLeft: "5px" }}
                          />
                        </li>
                      </ul>
                    </div>
                    <form className="d-flex justify-content-end py-2">
                      <Form.Control
                        type="text"
                        placeholder="이름 / 학번 검색"
                        className="me-3"
                        style={{ width: '188px' }}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      <Button variant="primary" onClick={handleDownloadExcel}>
                        <i className="bi bi-download"></i>
                      </Button>
                    </form>
                  </div>

                  {/* 테이블 */}
                  <div style={{ overflowX: 'auto' }}>
                    <Table>
                      {/* THEAD */}
                      <thead>
                        <tr>
                          <td
                            rowSpan={3}
                            className="align-middle border border-start-0 border-end-0"
                            style={{ background: '#EBF1FA', minWidth: '100px' }}
                          >
                            <div className="d-flex justify-content-center align-items-center">번호</div>
                          </td>
                          <td
                            rowSpan={3}
                            className="align-middle border border-start-0 border-end-0"
                            style={{ minWidth: '130px' }}
                          >
                            <div className="d-flex justify-content-center align-items-center">이름</div>
                          </td>
                          <td
                            rowSpan={3}
                            className="align-middle border border-start-0 border-end-0"
                            style={{ minWidth: '130px' }}
                          >
                            <div className="d-flex justify-content-center align-items-center">학번</div>
                          </td>
                          <td
                            rowSpan={3}
                            className="align-middle border border-start-0 border-end-0"
                            style={{ minWidth: '170px' }}
                          >
                            <div className="d-flex justify-content-center align-items-center">학과</div>
                          </td>
                          <td
                            rowSpan={3}
                            className="align-middle CHA_LIGHT border"
                            style={{ minWidth: '120px' }}
                          >
                            <div className="d-flex justify-content-center align-items-center">출석 / <br />공결일수</div>
                          </td>
                          <td
                            rowSpan={3}
                            className="align-middle CHA_LIGHT border"
                            style={{ minWidth: '120px' }}
                          >
                            <div className="d-flex justify-content-center align-items-center">지각일수</div>
                          </td>
                          <td
                            rowSpan={3}
                            className="align-middle CHA_LIGHT border"
                            style={{ minWidth: '120px' }}
                          >
                            <div className="d-flex justify-content-center align-items-center">결석일수</div>
                          </td>
                          {teacherAttendanceList &&
                            teacherAttendanceList[0]?.attendanceSummaryDtoList.map((module) => {
                              const colSpanValue = module.attendanceSummaries.length;
                              return (
                                <td
                                  key={module.moduleNumber}
                                  colSpan={colSpanValue}
                                  className="border"
                                  style={{ minWidth: `${colSpanValue * 150}px` }}
                                >
                                  <div className="d-flex justify-content-center">{module.moduleNumber}주차</div>
                                </td>
                              );
                            })}
                        </tr>
                        <tr>
                          {teacherAttendanceList &&
                            teacherAttendanceList[0]?.attendanceSummaryDtoList.map((module) => {
                              return module.attendanceSummaries.map((summary, summaryIndex) => (
                                <td key={`${module.moduleNumber}-${summaryIndex}`} className="border">
                                  <div className="d-flex justify-content-center">{summary.date}</div>
                                </td>
                              ));
                            })}
                        </tr>
                        <tr>
                          {teacherAttendanceList &&
                            teacherAttendanceList[0]?.attendanceSummaryDtoList.map((module) => {
                              return module.attendanceSummaries.map((summary, summaryIndex) => (
                                <td key={`${module.moduleNumber}-${summaryIndex}-content`} className="border">
                                  <div className="d-flex justify-content-center">{summary.contentNumber}교시</div>
                                </td>
                              ));
                            })}
                        </tr>
                      </thead>

                      {/* TBODY */}
                      <tbody>
                        {attendanceDisplayStudents?.map((item, index) => {
                          const attendanceData = teacherAttendanceList?.find(
                            (student) => student.userNumber === item.userNumber
                          );

                          return (
                            <tr key={index}>
                              {/* 기본 정보 */}
                              <td
                                className="border border-start-0 border-end-0 border-top-0 border-bottom-0"
                                style={{ background: '#EBF1FA' }}
                              >
                                <div className="d-flex justify-content-center">{index + 1}</div>
                              </td>
                              <td className="border border-start-0 border-end-0 border-top-0 border-bottom-0">
                                <div
                                  className="d-flex justify-content-center"
                                >
                                  {item.name.trim()}
                                </div>
                              </td>
                              <td className="border border-start-0 border-end-0 border-top-0 border-bottom-0">
                                <div className="d-flex justify-content-center">{item.userNumber}</div>
                              </td>
                              <td className="border border-start-0 border-end-0 border-top-0 border-bottom-0">
                                <div className="d-flex justify-content-center">{item.subDivision}</div>
                              </td>
                              <td className="border border-end-0 border-top-0 border-bottom-0">
                                <div className="d-flex justify-content-center">{attendanceData?.attendanceCnt || '-'}</div>
                              </td>
                              <td className="border border-top-0 border-bottom-0">
                                <div className="d-flex justify-content-center">{attendanceData?.lateCnt || '-'}</div>
                              </td>
                              <td className="border border-start-0 border-top-0 border-bottom-0">
                                <div className="d-flex justify-content-center">{attendanceData?.absenceCnt || '-'}</div>
                              </td>
                              {/* 상세 출결 상태 출력 */}
                              {attendanceData?.attendanceSummaryDtoList?.map((module, moduleIndex) =>
                                module.attendanceSummaries.map((summary, summaryIndex) => (
                                  <td
                                    key={`${index}-${moduleIndex}-${summaryIndex}`}
                                    className="border border-start-0 border-top-0 border-bottom-0"
                                  >
                                    <div className="d-flex justify-content-center">
                                      <AttendState state={summary.attendanceState} />
                                    </div>
                                  </td>
                                ))
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </>
            </Tab>
            <Tab eventKey="profile" title="출석평가표">
              <div className="row mb-3">
                <label htmlFor="attendanceTeacherSelectBox" className="fw-bold col-3 d-flex align-items-center">
                  현장 출석부 사용 여부
                </label>
                <Form.Select
                  id="attendanceTeacherSelectBox"
                  name="useFlag" // 반드시 name 속성을 지정
                  className="col-auto"
                  style={{ width: "200px" }}
                  value={attendanceSetting.useFlag}
                  onChange={handleInputChange}
                >
                  <option value="Y">예</option>
                  <option value="N">아니오</option>
                </Form.Select>
              </div>

              <div className="border border-start-0 border-end-0 pt-3 pb-2 mb-5">
                <div className="row my-2">
                  <label htmlFor="attendanceInputTotalPoint" className="fw-bold col-3 d-flex align-items-center">
                    현장 출석 총 점수
                  </label>
                  <input
                    className="p-2 border col-auto rounded"
                    type="number"
                    name="totalPoint" // 반드시 name 속성을 지정
                    id="attendanceInputTotalPoint"
                    style={{ width: "200px" }}
                    value={attendanceSetting.totalPoint}
                    onChange={handleInputChange}
                    disabled={attendanceSetting.useFlag === "N"}
                  />
                </div>

                <div className="row my-2">
                  <label htmlFor="attendanceInputMinPoint" className="fw-bold col-3 d-flex align-items-center">
                    출석 점수
                  </label>
                  <input
                    className="p-2 border col-auto rounded"
                    type="number"
                    name="minPoint" // 반드시 name 속성을 지정
                    id="attendanceInputMinPoint"
                    style={{ width: "200px" }}
                    value={attendanceSetting.minPoint}
                    onChange={handleInputChange}
                    disabled={attendanceSetting.useFlag === "N"}
                  />
                </div>

                <div className="row my-2">
                  <label htmlFor="attendanceInputLatePenalty" className="fw-bold col-3 d-flex align-items-center">
                    지각 차감
                  </label>
                  <input
                    className="p-2 border col-auto rounded"
                    type="number"
                    name="latePenaltyPoint" // 반드시 name 속성을 지정
                    id="attendanceInputLatePenalty"
                    style={{ width: "200px" }}
                    value={attendanceSetting.latePenaltyPoint}
                    onChange={handleInputChange}
                    disabled={attendanceSetting.useFlag === "N"}
                  />
                </div>

                <div className="row my-2">
                  <label htmlFor="attendanceInputAbsencePenalty" className="fw-bold col-3 d-flex align-items-center">
                    결석 차감
                  </label>
                  <input
                    className="p-2 border col-auto rounded"
                    type="number"
                    name="absencePenaltyPoint" // 반드시 name 속성을 지정
                    id="attendanceInputAbsencePenalty"
                    style={{ width: "200px" }}
                    value={attendanceSetting.absencePenaltyPoint}
                    onChange={handleInputChange}
                    disabled={attendanceSetting.useFlag === "N"}
                  />
                </div>
              </div>

              <div className="d-flex justify-content-center">
                <Button className="mx-1" variant="primary" onClick={handleAttendanceSettingSubmit}>
                  등록
                </Button>
                <Button className="mx-1" variant="secondary">
                  취소
                </Button>
              </div>
            </Tab>
          </Tabs>
        ) : (
          user.role === "ADMIN" ? (
            <p className="text-center mt-4">학과 및 과목을 선택해주세요.</p>
          ) : (
            <p className="text-center mt-4">과목을 선택해주세요.</p>
          )
        )}
        {visiblePopup && (
          <AttendancePopup
            setVisiblePopup={setVisiblePopup}
            studentId={selectedStudent.studentId}
            name={selectedStudent.name}
            statusList={selectedStudent.statusList} // attendanceStates 전달
          />
        )}
    </>
  );
};
